import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, formDataBuilder } from 'services';
import {
  ReleaseInvoicesToTrackingActions as Actions,
  ReleaseInvoicesToTrackingRequestAction as RequestAction,
} from 'store/ducks/pendingRelease';

export function* releaseInvoicesToTrackingRequest(action: any) {
  const { payload, onSuccess, onFailure }: RequestAction = action;
  try {
    const formData = formDataBuilder(payload);
    const { data } = yield call(api.post, `invoices/release_tracking`, formData);
    notify('success', "NFs liberadas com sucesso!");
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
